const LAYOUT_ORIENTATION = {
  VERTICAL: 'VERTICAL',
  HORIZONTAL: 'HORIZONTAL',
};

export default LAYOUT_ORIENTATION;
